import { getUserInfo, loginWithPassword } from '@/api/user'
import { removeToken, setToken, setRefreshToken, removeRefreshToken } from '@/utils/auth';
import { defineStore } from 'pinia'

export const userStore = defineStore({
  id: 'user',
  state: () => ({
    accountId: null,
    name: null
  }),
  // getters: {
  //   accountId: (state) => state.accountId,
  //   name: (state) => state.name
  // },
  actions: {
    async login(username, password, clientId, autocode) {      
      try {
          const result = await loginWithPassword(username, password, clientId, autocode);
          console.log('result', result)
          setToken(result.accessToken);
          setRefreshToken(result.refreshToken);
          await this.getUser();
      }
      catch(e){
        return Promise.reject(e);
      }
    },

    async getUser() {
      try{
        const user = await getUserInfo();
        console.log('user', user);
        this.accountId = user.userAccount;
        this.name = user.displayName;
        console.log('this.accountId', this.accountId);
        // this.userGuid = user.userGuid;
      }
      catch(e){
        return Promise.reject(e);
      }
    },

    logout() {      
      this.accountId = null;
      this.name = null;
      removeToken();
      removeRefreshToken();
    }
  }
})
